/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EmployeeDataFlowEdge,
  EmployeeDataFlowEdge$inboundSchema,
} from "./employeedataflowedge.js";
import {
  EmployeeDataFlowNode,
  EmployeeDataFlowNode$inboundSchema,
} from "./employeedataflownode.js";

/**
 * Result of employee data flow graph query
 */
export type GetEmployeeDataFlowGraphResult = {
  /**
   * Weighted graph edges between adjacent populated tiers
   */
  edges: Array<EmployeeDataFlowEdge>;
  /**
   * Graph nodes grouped by tier
   */
  nodes: Array<EmployeeDataFlowNode>;
};

/** @internal */
export const GetEmployeeDataFlowGraphResult$inboundSchema: z.ZodMiniType<
  GetEmployeeDataFlowGraphResult,
  unknown
> = z.object({
  edges: z.array(EmployeeDataFlowEdge$inboundSchema),
  nodes: z.array(EmployeeDataFlowNode$inboundSchema),
});

export function getEmployeeDataFlowGraphResultFromJSON(
  jsonString: string,
): SafeParseResult<GetEmployeeDataFlowGraphResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetEmployeeDataFlowGraphResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetEmployeeDataFlowGraphResult' from JSON`,
  );
}
